import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule, SystemJsNgModuleLoader } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Http } from "@angular/http";
import { CookieService } from "angular2-cookie/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgAppListService } from "../ng-app-list/ng-app-list.service";

import { NgAssetTagsModule } from "./ng-components/ng-asset-tags/ng-asset-tags.module";
import { NgAlertModule } from "./ng-components/ng-alert/ng-alert.module";
import { NgToastrModule } from "./ng-components/ng-toastr/ng-toastr.module";
import { NgAppIconDirective } from "./ng-directives/ng-app-icon.directive";
import { NgTscOrchestratorService } from "./ng-services/ng-tsc-orchestrator.service";
import { NgAnalyticsService } from "./ng-services/ng-analytics.service";
import { NgApplicationTenancyService } from "./ng-services/ng-applications.service";
import { NgEnvVarsService } from "./ng-services/ng-env-vars.service";
import { NgTagsService } from "./ng-services/ng-tags.service";
import { NgUiDiscovery } from "./ng-services/ng-ui-discovery";
import { NgToolsService } from "./ng-util/ng-tools.service";
import { NgWsDiscoveryService } from "./ng-services/ng-ws-discovery.service";
import { NgModelerService } from "./ng-services/ng-ws-modeler.service";
import { NgSecurityService } from "./ng-services/ng-security.service";
import { NgWindowRefService } from "./ng-services/ng-window-ref.service";
import { NgUAPService } from "./ng-services/ng-uap.service";
// import { Ng1PartsModule } from "../ng-tenant/ng1-parts.module";
import { NgHelpModule } from "./ng-components/ng-help/ng-help.module";
import { NgUserService } from "./ng-services/ng-user.service";
import { NgWebSocketService } from "./ng-services/ng-websocket.service";
import { NgCategoryIconModule } from "./ng-directives/ng-category-icon/ng-category-icon.module";
import { NgVisibilityIconModule } from "./ng-directives/ng-visibility-icon/ng-visibility-icon.module";
import {
    NgCustomizationProviderService,
    NgTenantCustomizationProviderService
} from "./ng-services/ng-customization-provider.service";
import { TciTenantService } from "../ng-tenant/tci-tenant.service";
import { TciTenantModelService } from "../ng-tenant/tci-tenant.model";
import { NgTCIPipeModule } from "./ng-directives/ng-tci-pipe/ng-tci-pipe.module";
import { NgAppFeatureToggleService } from "./ng-services/ng-app-feature-toggle.service";
import { NgAppChangeNotificationService } from "./ng-services/ng-app-change-notification.service";
import { NgToastrService } from "./ng-components/ng-toastr/ng-toastr.service";
import { NgChartsModule } from "./ng-components/ng-charts/ng-charts.module";
// Base services
import { BaseAppHMMarkLiveService } from "../ng-app-hamburger-menu/ng-app-mark-live/base-app-hm-mark-live.service";
import { BaseAppDetailEnvService } from "../ng-app-details/ng-app-tabs/ng-apps-env/base-app-detail-env.service";
import { BaseAppDetailSetEndpointService } from "../ng-app-hamburger-menu/ng-app-set-endpoint/base-app-hm-set-endpoint.service";
import { BaseSubmenuAutoScalingService } from "../ng-app-details/ng-app-tabs/ng-apps-env/submenu-left-tabs/ng-submenu-auto-scaling/base-submenu-auto-scaling.service";
import { NgGraphBarModule } from "./ng-components/ng-bar-graph/ng-bar-graph.module";
import { NgOrgChangeNotificationService } from "./ng-services/ng-org-change-notification.service";
import { NgMediaModule } from "./ng-components/ng-media/ng-media.module";
import { NgRatingsModule } from "./ng-components/ng-ratings/ng-ratings.module";
import { NgUploadModule } from "./ng-components/ng-upload/ng-upload.module";
import { NgMarkdownEditorModule } from "./ng-components/ng-markdown-editor/ng-markdown-editor.module";
import { NgPopupModule } from "./ng-components/ng-popup/ng-popup.module";
import { NgIFrameModule } from "./ng-components/ng-iframe/ng-iframe.module";

function NgEnvVarsServiceFactory(http: Http): NgEnvVarsService {
    return NgEnvVarsService.getInstance(http);
}

function NgTscOrchestratorServiceFactory(http: Http): NgTscOrchestratorService {
    return NgTscOrchestratorService.getInstance(http);
}

function NgTagsServiceFactory(http: Http): NgTagsService {
    return NgTagsService.getInstance(http);
}

function NgTenantCustomizationProviderServiceFactory(
    envVarSvc: NgEnvVarsService,
    ngUiDiscovery: NgUiDiscovery
): NgTenantCustomizationProviderService {
    return NgTenantCustomizationProviderService.getInstance(envVarSvc, ngUiDiscovery);
}

function NgWebsocketServiceFactory(): NgWebSocketService {
    return NgWebSocketService.getInstance();
}

function NgCustomizationProviderServiceFactory(
    tenantSvc: TciTenantService,
    modelSvc: TciTenantModelService,
    envVarSvc: NgEnvVarsService,
    tenantCustomizationProviderServiceFactory: NgTenantCustomizationProviderService
): NgCustomizationProviderService {
    return NgCustomizationProviderService.getInstance(
        tenantSvc,
        modelSvc,
        envVarSvc,
        tenantCustomizationProviderServiceFactory
    );
}

function NgUserServiceFactory(cookieService: CookieService, http: Http): NgUserService {
    return NgUserService.getInstance(cookieService, http);
}

function NgAppFeatureToggleServiceFactory(): NgAppFeatureToggleService {
    return NgAppFeatureToggleService.getInstance();
}

function NgAppChangeNotificationServiceFactory(http: Http): NgAppChangeNotificationService {
    return NgAppChangeNotificationService.getInstance(http);
}

function NgOrgChangeNotificationServiceFactory(ngUserService: NgUserService): NgOrgChangeNotificationService {
    return NgOrgChangeNotificationService.getInstance(ngUserService);
}

// Base services
function BaseAppDetailEnvServiceFactory(
    http: Http,
    security: NgSecurityService,
    tenantModel: TciTenantModelService,
    userService: NgUserService,
    appsAPISrv: NgAppListService,
    appRefreshNotifSvc: NgAppChangeNotificationService
): BaseAppDetailEnvService {
    return BaseAppDetailEnvService.getInstance(http, security, tenantModel, userService, appsAPISrv, appRefreshNotifSvc);
}

function BaseAppDetailMarkLiveServiceFactory(http: Http): BaseAppHMMarkLiveService {
    return BaseAppHMMarkLiveService.getInstance(http);
}

function BaseAppDetailSetEndpointsServiceFactory(http: Http): BaseAppDetailSetEndpointService {
    return BaseAppDetailSetEndpointService.getInstance(http);
}

// function BaseAppDetailMonitoringServiceFactory(
//     injector: Injector,
//     http: Http,
//     security: NgSecurityService,
//     tenantModel: TciTenantModelService,
//     userService: NgUserService
// ): BaseAppDetailMonitoringService {
//     return BaseAppDetailMonitoringService.getInstance(injector, http, security, tenantModel, userService);
// }
function BaseSubmenuAutoScalingServiceFactory(
    http: Http,
    envCtrlSvc: BaseAppDetailEnvService
): BaseSubmenuAutoScalingService {
    return BaseSubmenuAutoScalingService.getInstance(http, envCtrlSvc);
}

function ngUiDiscoveryFactory(http: Http, envVarService: NgEnvVarsService, toastr: NgToastrService, userService: NgUserService) {
    return NgUiDiscovery.getInstance(http, envVarService, toastr, userService);
}

@NgModule({
    imports: [
        CommonModule,
        // Ng1PartsModule, // Important to put it here to initialize the loading
        NgAssetTagsModule,
        NgAlertModule,
        NgToastrModule,
        NgCategoryIconModule,
        NgVisibilityIconModule,
        NgTCIPipeModule,
        NgGraphBarModule,
        NgMediaModule,
        NgRatingsModule,
        NgUploadModule,
        NgMarkdownEditorModule,
        NgPopupModule,
        NgIFrameModule
    ],
    declarations: [
        NgAppIconDirective
    ],
    providers: [
        NgAnalyticsService,
        NgApplicationTenancyService,
        NgToolsService,
        NgWsDiscoveryService,
        NgModelerService,
        NgUAPService,
        NgSecurityService,
        {
            provide: NgUiDiscovery,
            useFactory: ngUiDiscoveryFactory,
            deps: [
                Http,
                NgEnvVarsService,
                NgToastrService,
                NgUserService
            ]
        },
        {
            provide: NgWebSocketService,
            useFactory: NgWebsocketServiceFactory
        },
        {
            provide: NgEnvVarsService,
            useFactory: NgEnvVarsServiceFactory,
            deps: [
                Http
            ]
        },
        {
            provide: NgTagsService,
            useFactory: NgTagsServiceFactory,
            deps: [
                Http
            ]
        },
        {
            provide: NgTscOrchestratorService,
            useFactory: NgTscOrchestratorServiceFactory,
            deps: [
                Http
            ]
        },
        {
            provide: NgTenantCustomizationProviderService,
            useFactory: NgTenantCustomizationProviderServiceFactory,
            deps: [
                NgEnvVarsService,
                NgUiDiscovery
            ]
        },
        {
            provide: NgCustomizationProviderService,
            useFactory: NgCustomizationProviderServiceFactory,
            deps: [
                TciTenantService,
                TciTenantModelService,
                NgEnvVarsService,
                NgTenantCustomizationProviderService
            ]
        },
        {
            provide: NgUserService,
            useFactory: NgUserServiceFactory,
            deps: [
                CookieService,
                Http
            ]
        },
        {
            provide: NgAppFeatureToggleService,
            useFactory: NgAppFeatureToggleServiceFactory,
            deps: []
        },
        {
            provide: NgAppChangeNotificationService,
            useFactory: NgAppChangeNotificationServiceFactory,
            deps: [
                Http
            ]
        },
        {
            provide: NgOrgChangeNotificationService,
            useFactory: NgOrgChangeNotificationServiceFactory,
            deps: [NgUserService]
        },
        // Base services
        {
            provide: BaseAppDetailEnvService,
            useFactory: BaseAppDetailEnvServiceFactory,
            deps: [
                Http,
                NgSecurityService,
                TciTenantModelService,
                NgUserService,
                NgAppListService,
                NgAppChangeNotificationService
            ]
        },
        {
            provide: BaseAppHMMarkLiveService,
            useFactory: BaseAppDetailMarkLiveServiceFactory,
            deps: [
                Http
            ]
        },
        {
            provide: BaseAppDetailSetEndpointService,
            useFactory: BaseAppDetailSetEndpointsServiceFactory,
            deps: [
                Http
            ]
        },
        // {
        //
        //     provide: BaseAppDetailMonitoringService,
        //     useFactory: BaseAppDetailMonitoringServiceFactory,
        //     deps: [Injector, Http, NgSecurityService, TciTenantModelService, NgUserService]
        // },
        {
            provide: BaseSubmenuAutoScalingService,
            useFactory: BaseSubmenuAutoScalingServiceFactory,
            deps: [
                Http,
                BaseAppDetailEnvService
            ]
        }
    ],
    exports: [
        NgAssetTagsModule,
        NgAlertModule,
        NgToastrModule,
        NgCategoryIconModule,
        NgVisibilityIconModule,
        NgAppIconDirective,
        NgTCIPipeModule,
        NgGraphBarModule,
        NgHelpModule,
        TranslateModule,
        NgChartsModule,
        NgMarkdownEditorModule,
        NgPopupModule,
        NgIFrameModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NgSharedModule {

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: NgSharedModule,
            providers: [
                NgApplicationTenancyService,
                {
                    provide: NgEnvVarsService,
                    useFactory: NgEnvVarsServiceFactory,
                    deps: [
                        Http
                    ]
                },
                {
                    provide: NgTscOrchestratorService,
                    useFactory: NgTscOrchestratorServiceFactory,
                    deps: [
                        Http
                    ]
                },
                {
                    provide: NgAppFeatureToggleService,
                    useFactory: NgAppFeatureToggleServiceFactory,
                    deps: []
                },
                {
                    provide: NgOrgChangeNotificationService,
                    useFactory: NgOrgChangeNotificationServiceFactory,
                    deps: [NgUserService]
                },
                {
                    provide: NgTagsService,
                    useFactory: NgTagsServiceFactory,
                    deps: [
                        Http
                    ]
                },
                {
                    provide: NgAppChangeNotificationService,
                    useFactory: NgAppChangeNotificationServiceFactory,
                    deps: [
                        Http
                    ]
                },
                NgToolsService,
                NgWsDiscoveryService,
                NgModelerService,
                NgWindowRefService,
                SystemJsNgModuleLoader,
                {
                    provide: NgUiDiscovery,
                    useFactory: ngUiDiscoveryFactory,
                    deps: [
                        Http,
                        NgEnvVarsService,
                        NgToastrService,
                        NgUserService
                    ]
                },
                NgUAPService,
                {
                    provide: NgUserService,
                    useFactory: NgUserServiceFactory,
                    deps: [
                        CookieService,
                        Http
                    ]
                },
                NgSecurityService,
                {
                    provide: NgTenantCustomizationProviderService,
                    useFactory: NgTenantCustomizationProviderServiceFactory,
                    deps: [
                        NgEnvVarsService,
                        NgUiDiscovery
                    ]
                },
                {
                    provide: NgCustomizationProviderService,
                    useFactory: NgCustomizationProviderServiceFactory,
                    deps: [
                        TciTenantService,
                        TciTenantModelService,
                        NgEnvVarsService,
                        NgTenantCustomizationProviderService
                    ]
                }
            ]
        };
    }
}



